import { TrendingUp, Globe2, Users, Landmark, Globe, CircleCheck, Handshake } from "lucide-react";

export const PROFILE = {
  name: "Augustus Emenogu",
  email: "augustus.316@gmail.com",
  phoneGH: "+233 240 517 724",
  phoneNG: "+234 806 529 5046",
  linkedin: "https://www.linkedin.com/in/augustusemenogu",
  website: "https://evidence-clarity.emergent.host/",
  photo: "https://customer-assets.emergentagent.com/job_b2b1bb03-b1d7-487d-9aa9-174b530a5b9a/artifacts/4qpyvjjy_Passport%20Photo.jpg",
  coverageMap: "https://customer-assets.emergentagent.com/job_b2b1bb03-b1d7-487d-9aa9-174b530a5b9a/artifacts/vkg5wy72_Augustus%20Emenogu%20Capstat%20Map.png",
};

export const ROLES = [
  "MERLA Executive", "Evidence Broker", "Development Intrapreneur",
  "Evaluation Nomad", "Impact Strategist", "Venture Entrepreneur", "Research Advisory",
];

export const HERO_STATS = [
  { count: 20, suffix: "+", label: "Years Experience" },
  { count: 73, suffix: "", label: "Countries" },
  { count: 75, suffix: "+", label: "Reports Authored" },
  { count: 185, suffix: "+", label: "Global Experts Led" },
];

export const HERO_CERTS = ["ACIEH", "CAPM", "CDRP", "CKM", "FERMI", "ISO 27001"];

export const METRICS = [
  { icon: TrendingUp, count: 75, suffix: "+", static: null, label: "Evaluation & Research Reports" },
  { icon: Globe2, count: 73, suffix: "", static: null, label: "Countries Covered" },
  { icon: Users, count: 185, suffix: "+", static: null, label: "Expert Roster Built & Managed" },
  { icon: Handshake, count: null, suffix: "", static: "2,500+", label: "Stakeholders Engaged" },
  { icon: Globe, count: 30, suffix: "+", static: null, label: "Countries in Consultancy Practice" },
  { icon: CircleCheck, count: null, suffix: "", static: "$90M", label: "Grant Portfolio Reviewed (Risk Pool)" },
];

export const NAV_LINKS = [
  ["#about", "About"], ["#experience", "Experience"], ["#services", "Services"],
  ["#expertise", "Expertise"], ["#portfolio", "Portfolio"], ["#coverage", "Coverage"],
  ["#volunteering", "Volunteering"],
];
